<div #gaugeChart class="gauge{{index}} h-100 w-100">
    <p *ngIf="!gaugeData.length" class="mt">No Data</p>
</div>